module.exports = __webpack_public_path__ + "static/sailRankshome2-24f20795f39e01bebf446638eb36d956.png";